export default "__VITE_ASSET__aa68b00c__"